import { render, staticRenderFns } from "./orderItem.vue?vue&type=template&id=d0939bf2&scoped=true"
import script from "./orderItem.vue?vue&type=script&lang=js"
export * from "./orderItem.vue?vue&type=script&lang=js"
import style0 from "./orderItem.vue?vue&type=style&index=0&id=d0939bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0939bf2",
  null
  
)

export default component.exports